module.exports = __webpack_public_path__ + "static/media/demo03.7e33f27d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/demo03.png
// module id = 819
// module chunks = 0